import { createFileRoute } from '@tanstack/react-router';

import { preloadProgressData } from 'hooks/useQuery/useQueryProgressData';
import { preloadSourceApps } from 'hooks/useQuery/useQuerySourceApps';

import { DestinationsView } from 'views/DestinationsView';

export const Route = createFileRoute('/_auth/_layout/destinations/')({
  component: DestinationsView,
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([preloadSourceApps(queryClient), preloadProgressData(queryClient)]);
  },
});
